import styled from "styled-components";
import React from "react";
import message from "../../assets/svgs/Support.svg";
import tele from "../../assets/images/tele.png";
import { withRouter } from "react-router";
import http from "../../services/httpService";
import { maxScreenWidth } from "../../config.json";
import { createLeadLSApi } from "../../services/leadSquaredService";
import Routes from "../../constants/routes";

import HomeInactive from "../../assets/svgs/drawer_home_inactive.svg";
import HomeActive from "../../assets/svgs/drawer_home_active.svg";
import SupportInactive from "../../assets/svgs/drawer_phone_inactive.svg";
import SupportActive from "../../assets/svgs/drawer_phone_active.svg";
import ProfileInactive from "../../assets/svgs/drawer_profile_inactive.svg";
import ProfileActive from "../../assets/svgs/drawer_profile_active.svg";

class FooterDiv extends React.Component {
  support = {
    customer: {
      image: message,
      text: "Support",
    },
    prospect: {
      image: tele,
      text: "Call",
    },
  };

  constructor(props) {
    super(props);

    this.state = {
      benefitsNotifications: 0,
      loading: true,
    };
  }

  async componentDidMount() {
    let that = this;
    try {
      let { data } = await http.get("/dashboard/get_bought_policies/");
      const policies = data["data"] && data["data"].slice(0, 3);
      if (policies.length) {
        let LSBody = {
          EmailAddress: localStorage.getItem("email"),
        };
        let LSProperties = [
          "mx_Policy_Number",
          "mx_Policy_Number_2",
          "mx_Policy_Number_3",
        ];
        for (let i in policies) {
          LSBody[LSProperties[i]] = String(Object.keys(policies[Number(i)])[0]);
        }
        createLeadLSApi(LSBody);
        this.setState({ userType: "" });
      }
      this.setState({
        benefitsNotifications: data["data"] && data["data"].length,
        loading: false,
      });
    } catch (ex) {
      that.setState({
        loading: false,
      });
    }
  }

  onBenefitClick = () => {
    this.props.history.push("/benefits");
  };

  onProfileClick = () => {
    this.props.history.push(Routes["PROFILE"]);
  };

  chatClick = () => {
    // this.showVerloop()
    this.props.history.push("/support");
  };

  handleTap = (endpoint) => {
    this.props.history.push(endpoint);
  };

  showVerloop() {
    if (window.Verloop) {
      window.Verloop(function () {
        this.openWidget();
      });
    } else {
      const initVerloop = function (w, d, s, u) {
        w.Verloop = function (c) {
          w.Verloop._.push(c);
        };
        w.Verloop._ = [];
        w.Verloop.url = u;
        var h = d.getElementsByTagName(s)[0],
          j = d.createElement(s);
        j.async = true;
        j.src = "https://getvital.verloop.io/livechat/script.min.js";
        h.parentNode.insertBefore(j, h);
        window.Verloop(function () {
          this.setUserParams({
            name: localStorage.getItem("first_name"),
            email: localStorage.getItem("email"),
            phone: localStorage.getItem("phone"),
            user_id: localStorage.getItem("healthfront_id"),
          });
          const department = localStorage.getItem("department");
          if (department !== null || department !== undefined) {
            this.setCustomField("department", department, { scope: "user" });
          }
          this.openWidget();
        });
      };
      initVerloop(
        window,
        document,
        "script",
        "https://getvital.verloop.io/livechat"
      );
    }
  }

  showPlansTab = () => {
    const policies = JSON.parse(localStorage.getItem("policies"));
    // for (let i in policies){
    //   const policyType = (Object.values(policies[i])[0] || '').toLowerCase()
    //   if( policyType.indexOf('gmc') > -1 || policyType.indexOf('niva') > -1 || policyType.indexOf('kotak') > -1 )
    //   return false
    // }
    return true;
  };

  renderSupport = (path) => {
    const isFlex = localStorage.getItem("employee_plan_type") === "FLEX";
    let userType =
      this.state.benefitsNotifications > 0 ? "customer" : "prospect";
    const { support } = this;

    return (
      <CallTab onClick={this.chatClick}>
        <TabImage height="30px" width="auto" src={path.includes("support") ? SupportActive : SupportInactive} />
        <TabTitle
          style={{
            fontWeight: path.includes("support") ? "600" : "normal",
          }}>Support</TabTitle>
      </CallTab>
    );
  };

  render() {
    const path = this.props.location && this.props.location.pathname;
    return (
      <Footer show={!this.state.loading}>
        <Tab onClick={() => this.handleTap("/home")}>
          <TabImage
            height="30px"
            width="auto"
            src={path.includes("home") ? HomeActive : HomeInactive}
          />
          <TabTitle
            style={{
              fontWeight: path.includes("home") ? "600" : "normal",
            }}
          >
            Home
          </TabTitle>
        </Tab>

        {this.renderSupport(path)}

        <Tab
          onClick={() => this.handleTap("/profile")}
        >
          <TabImage
            height="30px"
            width="auto"
            src={path.includes("profile") ? ProfileActive : ProfileInactive}
          />
          <TabTitle
            style={{
              fontWeight: path.includes("profile") ? "600" : "normal",
            }}
          >
            Profile
          </TabTitle>
        </Tab>
      </Footer>
    );
  }
}

const Footer = styled.div`
  display: ${(props) => (props.show ? "flex" : "none")};
  flex-direction: row;
  width: 100%;
  align-items: center;
  box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.15);
  padding: 1rem 1rem 0.8rem 1rem;
  position: fixed;
  bottom: 0;
  max-width: ${maxScreenWidth};
  z-index: 999;
  background-color: #fff;
`;
const Tab = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: ${(props) => props.opacity};
`;

const CallTab = styled.a`
  display: flex;
  position: relative;
  flex-direction: column;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: ${(props) => props.opacity};
  text-decoration: none;
`;

const TabImage = styled.img`
  height: 26px;
  opacity: ${(props) => (props.opacity ? props.opacity : "1")};
`;

const TabTitle = styled.p`
  max-width: 100%;
  align-items: center;
  font-family: Inter;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.3px;
  text-align: center;
  color: rgba(0, 0, 0, 0.9);
  margin-top: 2px;
  text-transform: capitalize;
  &:click {
    opacity: 1;
  }
`;

const Notification = styled.div`
  display: flex;
  position: absolute;
  padding: 2px 8px;
  bottom: 65%;
  right: 2%;
  border-radius: 2px;
  background-color: #f27576;
  z-index: 12;
`;

export default withRouter(FooterDiv);
